import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { BannerService } from '@services/banner/banner.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { ActivatedRoute } from '@angular/router';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { FormDirective } from '../../../directives/form/form.directive';
import { MatDialog } from '@angular/material/dialog';
import { EnvironmentService } from '@services/environment/environment.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { SelectAssetsComponent } from '../../../components/select-assets/select-assets.component';
import { MediaAssetsService } from '@services/assets/media-assets.service';

@Component({
  selector: 'app-banner-edit',
  templateUrl: 'banner-edit.component.html',
  styleUrls: ['banner-edit.component.scss'],
  providers: [BannerService, MediaAssetsService],
  standalone: false
})

export class BannerEditComponent implements OnInit {
  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;
  options = { hideFields: false };

  public title = 'Create Banner';
  public subtitle = '';

  public pageActions: PageAction[];

  banner: Models.Banner;
  isLoading = false;
  image;
  imageUrl;

  bannerId;
  public mediaAssetPath: any;

  constructor(
    public bannerService: BannerService, private route: ActivatedRoute, private componentFactoryResolver: ComponentFactoryResolver, private snackbar: SnackbarService,
    private dialog: MatDialog, private environmentService: EnvironmentService, private mediaService: MediaAssetsService
  ) {
    this.mediaAssetPath = this.environmentService.getMediaAssetPath();
  }

  ngOnInit() {
    this.isLoading = true;
    if (this.route.snapshot.params['id']) {
      this.bannerId = this.route.snapshot.params['id'];
      this.initExisting();
    } else {
      this.initNew();
    }
  }

  private async initExisting() {
    this.banner = await this.bannerService.get(this.bannerId);
    this.image = (await this.mediaService.find(0, 1, { path: this.banner.image }))?.data?.[0];
    this.title = 'Edit Banner';
    if (this.banner.image) {
      this.imageUrl = this.mediaAssetPath + this.banner.image + '?t=' + Date.now();
    }
    this.loadForm();
  }

  private initNew() {
    this.isLoading = false;
    this.banner = <Models.Banner>Models.ModelFactory.createModelInstanceByName('Banner');
    this.loadForm();
  }

  private loadForm() {
    const formItem = DefaultFormComponent;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.banner;
    (<FormComponent>componentRef.instance).options = this.options;
    this.isLoading = false;
  }

  async onSave() {
    const result = await this.banner.validate(true);
    if (!result?.success) {
      return this.snackbar.open('Could not create the Banner, please fill in the form correctly');
    }
    if (this.bannerId) {
      await this.bannerService.patch(this.bannerId, this.banner);
      this.snackbar.success('Saved changes successfull', 2000);
    } else {
      const banner = await this.bannerService.create(this.banner);
      this.bannerId = banner._id;
      this.initExisting();
      this.snackbar.success('Saved new entry successfull');
    }
  }

  async chooseFromImageAssets() {
    const assets: Models.ImageAsset[] = await this.dialog.open(SelectAssetsComponent, {
      width: '880px', height: '75%', panelClass: 'select-assets-modal', data: { type: 'media', multiple: false, title: 'Bilder'}
    }).afterClosed().toPromise();
    if (assets?.[0]?.path) {
      this.imageUrl = this.mediaAssetPath + assets[0].path + '?t=' + Date.now();
      this.image = assets[0];
      this.banner.image = assets[0].path;
    }
  }

  cleanImage() {
    this.imageUrl = null;
    this.image = null;
    this.banner.image = null;
  }
}
